<template>
  <main class="app-container">

  </main>
</template>

<script>


export default {
  name: "home",
  components: {

  }
};
</script>


<style lang="scss" scoped>


</style>
